// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Settings } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconSettings(props: any) {
    return <IconBase icon={Settings} {...props} />
  }

  export default IconSettings
  